class SearchModal extends HTMLElement {
  constructor() {
    super()
    this.modalToggle = document.querySelectorAll("[aria-controls='search-modal']")
    this.detailsContainer = this.querySelector("div.header__search")
    this.modalOverlay = this.querySelector("div.header__search__overlay")
    this.modalToggle.forEach((btn) => {
      btn.addEventListener("click", this.onToggleClick.bind(this))
    })

    this.querySelector('button[type="button"]').addEventListener("click", this.closeModal.bind(this))
  }

  initialize() {}

  onToggleClick(event) {
    event.preventDefault()

    this.detailsContainer.hasAttribute("open") ? this.closeModal() : this.openModal(event)
  }

  openModal(event) {
    this.detailsContainer.setAttribute("open", "true")
    this.modalOverlay.addEventListener("click", this.overlayClick.bind(this))
    document.body.classList.add("overflow-hidden")

    trapFocus(
      this.detailsContainer.querySelector('[tabindex="-1"]'),
      this.detailsContainer.querySelector('input:not([type="hidden"])'),
    )
  }

  closeModal(focusToggle = true) {
    // removeTrapFocus(focusToggle ? this.modalToggle : null)
    this.detailsContainer.removeAttribute("open")
    const input = this.detailsContainer.querySelector('input:not([type="hidden"])')
    if (input) input.value = ""
    const predictive = this.detailsContainer.querySelector("#predictive-search")
    if (predictive) {
      predictive.innerHTML = ""
      predictive.classList.remove("predictive-search--visible")
      predictive.style.display = "none"
    }
    this.modalOverlay.removeEventListener("click", () => {})
    document.body.classList.remove("overflow-hidden")
  }

  overlayClick() {
    this.closeModal()
  }
}

customElements.define("search-modal", SearchModal)

/**
 * Header search modal live results. Uses a distinct tag from Dawn's `<predictive-search>`
 * so `assets/predictive-search.js` can register the same name on the search template.
 */
class HeaderPredictiveSearch extends HTMLElement {
  constructor() {
    super()

    this.input = this.querySelector('input[type="search"]')
    this.predictiveSearchResults = this.querySelector("#predictive-search")

    this.input.addEventListener(
      "input",
      this.debounce((event) => {
        this.onChange(event)
      }, 300).bind(this),
    )
  }

  onChange() {
    const searchTerm = this.input.value.trim()

    if (!searchTerm.length) {
      this.close()
      return
    }

    this.getSearchResults(searchTerm)
  }

  getSearchResults(searchTerm) {
    const base =
      typeof window !== "undefined" && window.routes && window.routes.predictive_search_url
        ? window.routes.predictive_search_url
        : "/search/suggest"
    const params = new URLSearchParams({
      q: searchTerm,
      "resources[type]": "product",
      "resources[limit]": "20",
      section_id: "predictive-search",
    })
    fetch(`${base}?${params.toString()}`)
      .then((response) => {
        if (!response.ok) {
          var error = new Error(response.status)
          this.close()
          throw error
        }

        return response.text()
      })
      .then((text) => {
        const doc = new DOMParser().parseFromString(text, "text/html")
        const section = doc.querySelector("#shopify-section-predictive-search")
        if (!section || !this.predictiveSearchResults) {
          this.close()
          return
        }
        this.predictiveSearchResults.innerHTML = section.innerHTML
        this.hydrateJdgmBadges(this.predictiveSearchResults)
        setTimeout(() => this.hydrateJdgmBadges(this.predictiveSearchResults), 300)
        this.open()
      })
      .catch((error) => {
        this.close()
        throw error
      })
  }

  open() {
    this.predictiveSearchResults.classList.add("predictive-search--visible")
    this.predictiveSearchResults.style.display = "block"
  }

  close() {
    this.predictiveSearchResults.classList.remove("predictive-search--visible")
    this.predictiveSearchResults.style.display = "none"
  }

  hydrateJdgmBadges(root) {
    if (!root) return
    if (typeof window.jdgm?.customBadges === "function") {
      window.jdgm.customBadges()
      return
    }
    root.querySelectorAll(".jdgm-preview-badge").forEach((el) => {
      if (typeof window.jdgm?.customBadge === "function") {
        window.jdgm.customBadge(el, { product_id: el.dataset.id })
      }
    })
  }

  debounce(fn, wait) {
    let t
    return (...args) => {
      clearTimeout(t)
      t = setTimeout(() => fn.apply(this, args), wait)
    }
  }
}

customElements.define("header-predictive-search", HeaderPredictiveSearch)
